<div id="otp-problems-container">
    <div class="row">
        <div class="col-4 col-pr-12 col-sm-8 col-md-12">
            <h1 class="title"> {{copyService.copies.otp_problem.title}}</h1>
            <div class="info">
                <p> {{copyService.copies.otp_problem.label_text1}}</p>
                <br>
                <p>{{copyService.copies.otp_problem.label_text2}}</p>
            </div>

            <div class="table-container">
                <vcl-table>
                    <table cdk-table [dataSource]="infoTable.dataSource">
                    <ng-container *ngFor="let title of infoTable.title" [cdkColumnDef]="title.key">
                        <th cdk-header-cell *cdkHeaderCellDef>{{ title.value }}</th>
                        <td cdk-cell *cdkCellDef="let element"> {{element[title.key] }} </td>
                    </ng-container> 
                    
                    <tr cdk-header-row *cdkHeaderRowDef="displayedColumns"></tr>
                    <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                    </vcl-table>
            </div>
        </div>
    </div>
</div>
<app-controls [hasPrevious]="true" [nextLabel]="copyService.copies.otp_problem.button_label" (next)="next()"></app-controls>